import { forwardRef } from 'react';
import { Alert as AntdAlert } from 'antd';
import clsx from 'clsx';
import styles from './Alert.module.css';

/**
 * @param {Object} props - Same shape as antd's own `Alert`, forwarded as-is.
 * @param {'success'|'info'|'warning'|'error'} [props.type] - Icon/colors themed via
 *   `ConfigProvider`'s `components.Alert` and `alert` prop; see `vector/NOTES.md`.
 * @param {'status'|'alert'|string} [props.role] - Defaults to the polite `status` (antd's own
 *   default is the assertive `alert`); pass `alert` only for urgent, unexpected messages.
 */
const Alert = forwardRef(({ className, role = 'status', ...props }, ref) => (
    <AntdAlert ref={ref} role={role} className={clsx(styles.vecAlert, className)} {...props} />
));
Alert.displayName = 'Alert';

export default Alert;
